module.exports = __webpack_public_path__ + "static/HungryMonster-80c3ba280e87d869f4ef501f4ac5f092.jpg";